import { QUERY_GET_FACTORY_SALESFORCE } from '../../fetch/constantQueries'
import { baseThunk } from '../../fetch/basicThunk';

export const getFactorySalesForce = baseThunk(`factorySalesForce/getSalesForce`, QUERY_GET_FACTORY_SALESFORCE, "GET")
